
<mat-card>
    <app-content-header-bar class="header" [title]="title" [subtitle]="subtitle"></app-content-header-bar>
    <mat-card-content>
      <p>
        Example of the Content Header Bar and the footer:
      </p>

      <label>Header Title </label>
      <input type="text" [(ngModel)]="title"> <br>

      <label>Header Subtitle </label>
      <input type="text" [(ngModel)]="subtitle"> <br>

      <label>Show The "Alert Button" </label>
      <input type="checkbox" [(ngModel)]="alertVisible" (ngModelChange)="alertVisible$.next($event)"><br>

      <label>Disable The "Alert Button" </label>
      <input type="checkbox" [(ngModel)]="alertDisabled" (ngModelChange)="alertDisabled$.next($event)"><br>

      <label>Footer Version </label>
      <input type="text" [(ngModel)]="version"> <br>

    </mat-card-content>
    <mat-card-footer>
        <app-footer [version]="version"></app-footer>
    </mat-card-footer>
</mat-card>

